<button
  mat-stroked-button
  color="primary"
  [disabled]="disabled"
  (click)="handleClick()">
    SMS
    <!-- <mat-icon>{{ showDropDown ? "arrow_drop_down" : "" }}</mat-icon> -->
</button>